import { Box, VStack } from "@chakra-ui/react";

import { ChakraText } from "components/ChakraText";
import { Modal } from "components/Modal";

import { RemindPasswordForm } from "./RemindPasswordForm";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
}

const RemindPasswordModal = ({ onClose, isOpen }: IProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      modalHeader={<ChakraText>Zresetuj hasło</ChakraText>}
    >
      <VStack spacing={4}>
        <Box w="100%">
          <RemindPasswordForm onCloseModal={onClose} />
        </Box>
      </VStack>
    </Modal>
  );
};

export { RemindPasswordModal };
